namespace RedBullMOBILE360.PushNotifications {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.PushNotifications.PushNotificationsPGGrid')
    export class PushNotificationsPGGrid extends Serenity.EntityGrid<PushNotificationsPGRow, any> {
        protected getColumnsKey() { return PushNotificationsPGColumns.columnsKey; }
        protected getDialogType() { return PushNotificationsPGDialog; }
        protected getIdProperty() { return PushNotificationsPGRow.idProperty; }
        protected getInsertPermission() { return PushNotificationsPGRow.insertPermission; }
        protected getLocalTextPrefix() { return PushNotificationsPGRow.localTextPrefix; }
        protected getService() { return PushNotificationsPGService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //if (!Q.Authorization.userDefinition.IsAdmin)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push({
                title: 'Import Custom Notifications',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new PushNotificationsExcelImportDialog();
                    dialog.dialogOpen();
                }
            });

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Download Template',
                grid: this,
                service: PushNotificationsService.baseUrl + '/DownloadTemplate',
                onViewSubmit: () => this.onViewSubmit()
            }));

            return buttons;
        }
    }
}